import { SubtitleStatus } from 'src/interfaces/Datahub';
import * as yup from 'yup';
import { schemaDefault } from '../../SchemaDefault';

const commonSubtitleSchema = yup
  .object()
  .shape({
    status: yup.mixed<SubtitleStatus>().oneOf(Object.values(SubtitleStatus)).required(),
    language: yup.string().when('status', {
      is: (value: SubtitleStatus) => value === SubtitleStatus.ENABLED,
      then: (schema) => schema.required(),
    }),
    time: yup.number().min(0).required(),
  })
  .strict();

export default {
  change: schemaDefault.concat(commonSubtitleSchema).strict(),
  toggle: schemaDefault.concat(commonSubtitleSchema),
};
